/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/no-this-in-sfc */
import React, { useMemo, useState } from 'react';
import { makeStyles } from '@material-ui/core';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import _isArray from 'lodash/isArray';
import { ErrorToast } from '../../utils/Utils';

const useStyles = makeStyles({
  multiSearch: {
    width: (props) => props.width,
    background: (props) => (props.white ? '#FFFFFF' : '#f4f4f4'),
    border: '1px solid #000000',
    borderRadius: '4px',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '14px',
    color: 'rgba(0, 0, 0, 0.4)',
  },
  ellipsisMessage: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    width: (props) => props.labelWidth || '250px',
    whiteSpace: 'nowrap',
    display: 'block',
  },
});

// eslint-disable-next-line react/prop-types
const LazyMenuList = ({ children, innerRef, innerProps }) => {
  const [displayCount, setDisplayCount] = useState(20);
  const childrenArray = React.Children.toArray(children);
  const hasMore = displayCount < childrenArray.length;

  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (scrollHeight - scrollTop <= clientHeight + 50 && hasMore) {
      setDisplayCount((prev) => prev + 20);
    }
  };

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <div ref={innerRef} {...innerProps} onScroll={handleScroll} style={{ maxHeight: '200px', overflowY: 'auto' }}>
      {childrenArray.slice(0, displayCount)}
    </div>
  );
};

const MultiSelectAll = ({
  options,
  selectedOptions,
  onChange: mainOnChange,
  showValue,
  labelWidth,
  white,
  showSubtext = false,
  ...extraProps
}) => {
  const classes = useStyles({ width: extraProps.width, labelWidth, white });

  const optionsMultiSelect = useMemo(
    () => [
      { label: 'All', value: '*' },
      ...[
        ...(_isArray(selectedOptions) ? selectedOptions.filter((i) => i?.value !== '*') : []),
        ...(_isArray(selectedOptions)
          ? options?.filter((i) => !selectedOptions.map((j) => j?.value).includes(i?.value)) || []
          : options),
      ],
    ],
    [options, selectedOptions],
  );

  function getDropdownButtonLabel({ placeholderButtonLabel, value }) {
    if (value && value.some((o) => o.value === '*')) {
      return `${placeholderButtonLabel}: All`;
    }
    return `${placeholderButtonLabel}: ${value?.length || 0} selected`;
  }

  function onChange(value, event) {
    if (event.option?.isDisable) {
      ErrorToast(event.option?.msg);
    } else if (event.action === 'select-option' && event.option.value === '*') {
      this.setState(this.options);
    } else if (event.action === 'deselect-option' && event.option.value === '*') {
      this.setState([]);
    } else if (event.action === 'deselect-option') {
      this.setState(value.filter((o) => o.value !== '*'));
    } else if (value.length === this.options.length - 1) {
      this.setState(this.options);
    } else {
      this.setState(value);
    }
  }

  const formatOptionLabel = ({ label, value, isDisable }) => (
    <span
      style={{
        display: 'inline-block',
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          color: 'black',
        }}
      >
        <div style={isDisable ? { opacity: '0.4' } : { opacity: '1' }}>
          <div className={classes.ellipsisMessage}>{label}</div>
          {showSubtext && value !== '*' ? (
            <div style={{ fontSize: '12px', color: 'rgba(0, 0, 0, 0.6)', marginTop: '2px' }}>
              ID: {value}
            </div>
          ) : null}
        </div>
        {showValue ? <div>{value === '*' ? 'ID' : value}</div> : null}
      </div>
    </span>
  );

  return (
    <ReactMultiSelectCheckboxes
      options={optionsMultiSelect}
      className={classes.multiSearch}
      // eslint-disable-next-line react/jsx-no-bind
      getDropdownButtonLabel={getDropdownButtonLabel}
      value={
        selectedOptions?.length === optionsMultiSelect.length - 1
          ? [{ label: 'All', value: '*' }, ...(selectedOptions || [])]
          : selectedOptions
      }
      // eslint-disable-next-line react/jsx-no-bind
      onChange={onChange}
      setState={mainOnChange}
      formatOptionLabel={formatOptionLabel}
      styles={{
        control: (provided) => ({
          ...provided,
          backgroundColor: white ? '#FFFFFF' : '#f4f4f4',
        }),
        dropdownButton: (baseProvided) => ({
          ...baseProvided,
          background: white ? '#FFFFFF' : '#f4f4f4',
          border: 'none',
        }),
      }}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...extraProps}
      components={{ MenuList: LazyMenuList }}
    />
  );
};

export default MultiSelectAll;
